"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeHTML = decodeHTML;
exports.stripHTML = stripHTML;

function stripHTML() {
  var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!html) {
    return '';
  }

  return html.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
}

function decodeHTML(html) {
  var txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.textContent;
}